module.exports = __webpack_public_path__ + "img/printer.f641d45.svg";